import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import _ from 'lodash';

import DepartUserTagSelector from '@/page/admin/selector/DepartUserTagSelector';
import {useClientAppGlobalAllows} from '../clientAppService';
import {allowList2Obj, allowObj2List} from './appAllowUtils';
import GlobalAllowsView from './GlobalAllowsView';
import {saveGlobalAllows} from '@/api/clientApps';

GlobalAllowsMeta.propTypes = {
    clientAppId: PropTypes.string,
};

function GlobalAllowsMeta({clientAppId}) {
    const DepartUserTagSelectorRef = useRef();

    const {value, loading, retry} = useClientAppGlobalAllows(clientAppId);
    const allows = allowList2Obj(value);
    console.log(':::GlobalAllowsMeta value, loading', value, loading);

    function onShowClick() {
        DepartUserTagSelectorRef.current.showModal({
            modalTitle: '可见范围选择',
            initialValues: allows,
        });
    }

    function onAllowSelect(values) {
        console.log('onAllowSelect', values);
        const allowObj = allowObj2List(values);
        console.log('allowObj', allowObj);
        return saveGlobalAllows(clientAppId, allowObj).then(() => {
            retry();

            return true;
        });
    }

    return (
        <>
            {_.isEmpty(value) ? (
                <Button size="small" onClick={onShowClick}>
                    未定义
                </Button>
            ) : (
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <GlobalAllowsView showEmpty={false} allowObj={allows} />
                    <div>
                        <Button size="small" onClick={onShowClick}>
                            修改
                        </Button>
                    </div>
                </div>
            )}

            <DepartUserTagSelector
                ref={DepartUserTagSelectorRef}
                showAdTagTab
                onSelect={onAllowSelect}
            />
        </>
    );
}

export default GlobalAllowsMeta;
